module.exports = __webpack_public_path__ + "static/media/gowago.91cc47e0.png";